export default __webpack_public_path__ + "static/media/page.27fef75a.jpg";